import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { handleTime } from '@ifeng-fe/container_channel/common/client/winter/mobile/utils/formatDate';
import styles from './index.css';

class FixTop extends React.PureComponent {
    static propTypes = {
        scrollTop: PropTypes.number,
        todayStr: PropTypes.string,
    };

    render() {
        const { scrollTop, todayStr } = this.props;

        return (
            <div className={scrollTop ? `${styles.topTime} ${styles.topShow}` : styles.topTime}>
                {handleTime(todayStr, 'ymd')}
            </div>
        );
    }
}

export default errorBoundary(FixTop);
